import marginCalculator from "@adapters/infrastructures/urlConfig/Tools/MarginCalculatorUrl";
import { calculateMarginMapper } from "@domains/features/Tools/MarginCalculator/mapper/calculateMarginMapper";
import { searchSymbolMapper } from "@domains/features/Tools/MarginCalculator/mapper/searchSymbolMapper";
import { derivativeDetailsMapper } from "@domains/features/Tools/MarginCalculator/mapper/derivativeDetailsMapper";
import { strikePriceListMapper } from "../../../../../domains/features/Tools/MarginCalculator/mapper/strikePriceListMapper";
class MarginCalcRepository {
    constructor(http) {
        this.http = http;
    }
    async calculateMargin(req) {
        const url = new URL(marginCalculator.calculateMargin);
        const result = await this.http.makeApiCall({
            url: url.toString(),
            method: "POST",
            body: req,
        });
        return calculateMarginMapper(result === null || result === void 0 ? void 0 : result.data);
    }
    async getSearchedSymbolData(req) {
        let searchUrl = marginCalculator.searchSymbol + "/" + req.searchText;
        const url = new URL(searchUrl);
        const result = await this.http.makeApiCall({
            url: url.toString(),
            method: "GET",
        });
        return searchSymbolMapper(result === null || result === void 0 ? void 0 : result.data);
    }
    async getDerivativeDetails(req) {
        const url = new URL(marginCalculator.getDerivative);
        url.searchParams.append("stkPrc", req.stkPrc);
        url.searchParams.append("und", req.und);
        url.searchParams.append("opTyp", req.opTyp);
        url.searchParams.append("exp", req.exp);
        url.searchParams.append("ins", req.ins);
        const result = await this.http.makeApiCall({
            url: url.toString(),
            method: "GET",
        });
        return derivativeDetailsMapper(result);
    }
    async getStrikePriceList(req) {
        const url = new URL(marginCalculator.getStrikePrice +
            `${"/" + req.und + "/" + req.ins + "/" + req.date + "/" + req.optionType}`);
        const result = await this.http.makeApiCall({
            url: url.toString(),
            method: "GET",
        });
        return strikePriceListMapper(result);
    }
}
export default MarginCalcRepository;
